<script setup>
import { onMounted, ref } from "vue";
import { api } from "../../services/api";
const emit = defineEmits(["changed"]);
const loaded = ref(false);
const busy = ref(true);
const error = ref("");
onMounted(async () => {
  try { loaded.value = (await api("imports/demo")).loaded; }
  catch (e) { error.value = e.message; }
  finally { busy.value = false; }
});
async function update() {
  const message = loaded.value
    ? "Retirer les établissements marqués comme démonstration et leurs projets ?"
    : "Ajouter les établissements, contacts et quatre projets fictifs du jeu de démonstration ?";
  if (!window.confirm(message)) return;
  busy.value = true;
  error.value = "";
  try {
    loaded.value = (await api("imports/demo", { method: "POST", body: { operation: loaded.value ? "remove" : "load" } })).loaded;
    emit("changed");
  } catch (e) { error.value = e.message; }
  finally { busy.value = false; }
}
</script>
<template>
  <details class="card">
    <summary>Jeu de démonstration</summary>
    <p>Des établissements et des contacts fictifs, sans accès Google, pour essayer les différents états des projets.</p>
    <p v-if="error" role="alert" class="alert">{{ error }}</p>
    <button :disabled="busy" @click="update">{{ busy ? "Traitement…" : loaded ? "Retirer la démonstration" : "Charger la démonstration" }}</button>
  </details>
</template>
